import React, { useEffect, useState } from 'react';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import usePersistedState from 'src/hooks/globalState/usePersistedState';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import StorageKeys from 'src/lib/storage/storageKeys';
import useIsLoggedIn from 'src/modules/authentication/hooks/useIsLoggedIn';
import NotificationPermissionDrawer from './NotificationPermissionDrawer';
import requestPermission from './requestPermission';
export default function useNotificationPermission() {
    const [permissionGranted, setPermissionGranted] = useState(false);
    const [isPermissionRequested, setIsPermissionRequested] = usePersistedState(StorageKeys.notificationPermissionRequested, false);
    const isLoggedIn = useIsLoggedIn();
    const showPermissionDrawer = useStableCallback(({ onAllow, onDeny, onRemindLater }) => {
        bottomDrawerHelperActions.show({
            component: (React.createElement(NotificationPermissionDrawer, { onAllow: async () => {
                    bottomDrawerHelperActions.hide();
                    onAllow();
                }, onDeny: () => {
                    bottomDrawerHelperActions.hide();
                    onDeny();
                }, onRemindLater: () => {
                    bottomDrawerHelperActions.hide();
                    onRemindLater();
                } })),
        });
    });
    useEffect(() => {
        if (isLoggedIn) {
            if (isPermissionRequested) {
                requestPermission().then(isEnabled => setPermissionGranted(isEnabled));
                return;
            }
            setIsPermissionRequested(true);
            showPermissionDrawer({
                onAllow() {
                    requestPermission().then(isEnabled => setPermissionGranted(isEnabled));
                },
                onDeny() {
                    setPermissionGranted(false);
                },
                onRemindLater() {
                    // Don't change the permission state, just close the drawer
                }
            });
        }
    }, [isLoggedIn]);
    return [permissionGranted, showPermissionDrawer];
}
